/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function HelpCircle({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" fillRule="evenodd" clipPath="url(#HelpCircle_svg__a)" clipRule="evenodd"><path d="M8 1.6a6.4 6.4 0 1 0 0 12.8A6.4 6.4 0 0 0 8 1.6ZM.4 8a7.6 7.6 0 1 1 15.2 0A7.6 7.6 0 0 1 .4 8Z" /><path d="M8.001 12.1a.839.839 0 1 1 0-1.678.839.839 0 0 1 0 1.678ZM8.001 5.1c-.638 0-1.156.518-1.156 1.156v.22a.6.6 0 1 1-1.2 0v-.22A2.356 2.356 0 0 1 8.001 3.9h.13A2.226 2.226 0 0 1 9.51 7.874l-.536.423a.98.98 0 0 0-.373.77v.043a.6.6 0 0 1-1.2 0v-.044c0-.667.306-1.298.83-1.711l.536-.423A1.026 1.026 0 0 0 8.13 5.1H8Z" /></g><defs><clipPath id="HelpCircle_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;